import {
  ABOUT,
  CONTACT,
  CREATOR,
  EVENTS,
  INFO,
  ADVERTISE,
} from 'constants/external-links';
import { FIND_YOUR_ORDER } from 'constants/routes';

export const EXTERNAL_COMPANY_LINKS = [
  {
    label: 'About',
    link: ABOUT,
  },
  {
    label: 'Find Your Order',
    link: FIND_YOUR_ORDER,
  },
  {
    label: 'Help',
    link: CONTACT,
  },
  {
    label: 'Contact',
    link: CONTACT,
  },
];

export const CONTACT_LINKS = [
  {
    label: 'For Creators',
    link: CREATOR,
  },
  {
    label: 'For Athletes',
    link: INFO,
  },
  {
    label: 'For PPV Events',
    link: EVENTS,
  },
  {
    label: 'For Advertisers',
    link: ADVERTISE,
  },
];

export const EXPLORE_LINKS = [
  {
    label: 'Join as an Athlete',
    onClick: true,
    link: '/',
  },
  {
    label: 'Join as a Creator',
    onClick: true,
    link: '/',
  },
  {
    label: 'Join as an Organization',
    onClick: true,
    link: '/',
  },
  {
    label: 'Join as a Fan',
    onClick: true,
    link: '/',
  },
];
